import React from 'react'; 
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {Box, IconButton} from "@mui/material";
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal} from "../../../state/ModalSlice/ModalSlice.ts";
import CloseIcon from "@mui/icons-material/Close";


export default function BuyCreditsModal() {

    const open = useAppSelector((state: RootState) => state.ModalSlice.BuyCreditsModalOpen)

    const Dispatch = useAppDispatch();

    function handleClose() {
        Dispatch(closeModal("BuyCreditsModalOpen"))
    }

    
    return (<React.Fragment>

            <Dialog
                sx={{
                    padding: 0,
                    '& .MuiPaper-root': {
                        borderRadius: '10px',
                    },
                }}
                maxWidth="md"
                open={open}
                PaperProps={{
                    component: 'div',

                }}
            >
                <DialogContent sx={{paddingX: "60px", paddingY: "50px"}} className={"bg-white"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>Get Credits</p>
                    </div>
                    <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton></div>
                    <div className={""}>
                        <div className={""}>
                            <div className={"flex w-full"}>
                                <div className={"w-[550px]"}>
                                    <Box
                                        component={"div"}
                                        // component="form"
                                        sx={{}}
                                    >
                                        <p>Please Contact <span
                                            className={"underline-offset-2 underline text-cc_link"}>support@hosaksham.com</span> to add more credits to your account.
                                        </p>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"flex gap-2 pt-8 justify-center"}>
                        <button onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                        }}
                                className={"w-[100%] bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg"}>Close
                        </button>
                    </div>
                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}